import React, { useContext, useEffect, useState, createContext } from 'react'
import PropTypes from 'prop-types'

const ListenerContext = createContext()

export const ListenerProvider = ({ children }) => {
  const [keyboard, setKeyboard] = useState(null)

  const [mobileDetect, setMobileDetect] = useState({
    isLargeScreen: window.innerWidth >= 900 && window.innerWidth <= 1199,
    isMediumScreen: window.innerWidth <= 925,
    isSmallScreen: window.innerWidth <= 899,
    isMobile: window.innerWidth <= 768,
    isTablet: window.innerWidth > 480 && window.innerWidth <= 768,
    isBigScreen: window.innerWidth <= 599,
    isPhone: window.innerWidth <= 480,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    orientation: window.innerWidth < window.innerHeight ? 'PORTRAIT' : 'LANDSCAPE',
    isDesktop: window.innerWidth > 900,
    isTabletRange: window.innerWidth > 599 && window.innerWidth <= 899
  })

  useEffect(() => {
    document.addEventListener('keydown', e => e.code !== 'ArrowDown' && e.code !== 'ArrowUp' && handleKeypress(e))
    window.addEventListener('resize', handleResize)

    return () => {
      document.removeEventListener('keydown', e => handleKeypress(e))
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleKeypress = (e) => {
    setKeyboard(e)
  }

  const handleResize = () => {
    setMobileDetect({
      isLargeScreen: window.innerWidth >= 900 && window.innerWidth <= 1199,
      isMediumScreen: window.innerWidth <= 925,
      isSmallScreen: window.innerWidth <= 899,
      isMobile: window.innerWidth <= 768,
      isTablet: window.innerWidth > 480 && window.innerWidth <= 768,
      isBigScreen: window.innerWidth <= 599,
      isPhone: window.innerWidth <= 480,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      orientation: window.innerWidth < window.innerHeight ? 'PORTRAIT' : 'LANDSCAPE',
      isDesktop: window.innerWidth > 900,
      isTabletRange: window.innerWidth > 599 && window.innerWidth <= 899
    })
  }

  return (
    <ListenerContext.Provider value={{ keyboard, mobileDetect }}>
      {children}
    </ListenerContext.Provider>
  )
}

ListenerProvider.propTypes = {
  children: PropTypes.node.isRequired
}

// KEYBOARD HOOK
export const useKeyboardListener = (callback) => {
  const context = useContext(ListenerContext)

  useEffect(() => {
    if (callback && context.keyboard && context.keyboard.key) callback(context.keyboard.key)
  }, [context.keyboard])

  return context.keyboard && context.keyboard.key
}

// MOBILE DETECT HOOK
export const useMobileDetect = () => {
  const context = useContext(ListenerContext)
  return context.mobileDetect
}
